import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';
import { Options } from './mixins';

export function useMixins() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, confirmAndRemove, confirmAndDisable, confirmAndEnable } = useCrudActions();

    const model = reactive({
        id: route.params.id,
        feature: null,
        data: null,
        name: '',
        code: '',
        status: null,
        quantity: 0,
        receiveLimit: -1,
        receiveCounter: 0,
        startTime: new Date(),
        endTime: new Date(),
        canEnable: false,
        canDisable: false,
        canDelete: false
    });

    const fetch = executeAction({
        request: () => promotionService.code.get(model.id),
        onSuccess: ({ data }) => {
            model.id = data.id;
            model.feature = data.feature;
            model.data = data.data;
            model.name = data.name;
            model.code = data.code;
            model.status = data.status;
            model.quantity = data.quantity;
            model.receiveLimit = data.receiveLimit;
            model.receiveCounter = data.receiveCounter;
            model.startTime = new Date(data.startTime);
            model.endTime = new Date(data.endTime);
            model.canEnable = data.canEnable;
            model.canDisable = data.canDisable;
            model.canDelete = data.canDelete;
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.CODE.INDEX })
    });

    const actions = {
        remove: confirmAndRemove({
            request: () => promotionService.code.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_PROMOTION.CODE.INDEX })
        }),
        enable: confirmAndEnable({
            request: () => promotionService.code.enable(model.id),
            onSuccess: fetch
        }),
        disable: confirmAndDisable({
            request: () => promotionService.code.disable(model.id),
            onSuccess: fetch
        })
    };

    return { model, Options, fetch, actions };
}
